import { TypographySettings } from '@theme/globals/typography';
import { edgeSize } from '@theme/globals/sizing';
import { pxToRem } from '@theme/utils/sizing';

const calendar = {
  day: {
    hover: {
      background: {
        color: 'primary',
      },
      color: 'white',
    },
    selected: {
      background: {
        color: 'primary',
      },
      color: 'white',
      font: {
        weight: 'bold',
      },
    },
  },
  extend: () => `
    padding: ${edgeSize.small};
    min-width: fit-content;
  `,
  small: {
    day: {
      round: pxToRem(4),
    },
    fontSize: TypographySettings.body.size,
    lineHeight: TypographySettings.body.height,
    daySize: '30px',
  },
  medium: {
    fontSize: TypographySettings.body.size,
    lineHeight: TypographySettings.body.height,
    daySize: '36px',
  },
  large: {
    fontSize: TypographySettings.body.size,
    lineHeight: TypographySettings.body.height,
    daySize: '45px',
  },
};
export default calendar;
